import { useState } from 'react';
import { createColumnHelper } from '@tanstack/react-table';
import { PriceList, PriceListItem } from '../../../models/Shop';
import { GlobalSearch } from '../../GlobalSearch';
import CustomTable from '../../CustomTable';

interface PriceListTableProps {
  priceList: PriceList;
}

export default function PriceListTable({ priceList }: PriceListTableProps) {
  const [globalFilter, setGlobalFilter] = useState('');

  const columnHelper = createColumnHelper<PriceListItem>();
  const columns = [
    columnHelper.accessor('category', {
      header: () => 'Categoria',
      cell: (category) => category.getValue(),
      enableSorting: false,
    }),
    columnHelper.accessor('subCategory', {
      header: () => 'Sotto Categoria',
      cell: (subCategory) => subCategory.getValue(),
      enableSorting: false,
    }),
    columnHelper.accessor('name', {
      header: () => 'Nome',
      cell: (name) => name.getValue(),
      enableSorting: false,
    }),
    columnHelper.accessor('description', {
      header: () => 'Descrizione',
      cell: (description) => description.getValue(),
      enableSorting: false,
    }),
    columnHelper.accessor('notes', {
      header: () => 'Note',
      cell: (notes) => notes.getValue(),
      enableSorting: false,
    }),
    columnHelper.accessor('price', {
      header: () => 'Prezzo',
      cell: (price) => price.getValue(),
      enableSorting: true,
    }),
  ];

  return (
    <>
      <GlobalSearch
        style={{ fontSize: '14px' }}
        filterValue={globalFilter}
        onChange={(value) => setGlobalFilter(value)}
      />
      <CustomTable
        data={priceList.items}
        columns={columns}
        pageStartIndex={0}
        pageMaxSize={5}
        columnsVisibility={{}}
        globalFilter={globalFilter}
        setGlobalFilter={setGlobalFilter}
      />
    </>
  );
}
